import { render, staticRenderFns } from "./SetAlertPrice.vue?vue&type=template&id=38db87f4&"
import script from "./SetAlertPrice.vue?vue&type=script&lang=ts&"
export * from "./SetAlertPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports